import get from 'lodash/get';

const getAgreementsList = (state) => get(state, 'agreements.list', []) || [];
const getTopLevelCancel = (state) => get(state, 'agreements.cancelEligibility');

/**
 * Cancellation rules from the backend (`GET /my/agreements` may attach `cancelEligibility` to the
 * response root or to a contract row).
 */
export const selectCancelEligibility = (state) => {
  const list = getAgreementsList(state);
  const topLevel = getTopLevelCancel(state);
  if (topLevel) return topLevel;
  if (!list.length) {
    return { mode: 'self_serve' };
  }
  const withElig = list.find((a) => a.cancelEligibility);
  if (withElig?.cancelEligibility) return withElig.cancelEligibility;
  const complete = list.find((a) => a.status === 'complete' && (a.lineItems || a.term));
  if (complete?.cancelEligibility) return complete.cancelEligibility;
  return { mode: 'self_serve' };
};

/**
 * @returns {null|object} active commercial agreement (prefers `complete` with term).
 */
export const selectActiveCommercialAgreement = (state) => {
  const list = getAgreementsList(state);
  if (!list || !list.length) return null;
  const comp = list.find((a) => a.status === 'complete' && !a.isLegacyPandaDoc);
  if (comp) return comp;
  return list[0] || null;
};
